import React from 'react'
import { Link } from 'react-router-dom'

import styles from './header.module.sass'

export default ({ path, title, isActive, ...props }) => (
  <Link
    {...props}
    to={path}
    className={
      styles.navigation__item +
      ' ' +
      (isActive ? styles.navigation__item__active : '')
    }>
    {title}
  </Link>
)
